/** Matches API opt-out: COMMENT_NOTIFICATIONS_READ_ENABLED=false */
export function commentNotificationsReadEnabled() {
  return (
    String(import.meta.env.VITE_COMMENT_NOTIFICATIONS_READ_ENABLED ?? "true").toLowerCase() !==
    "false"
  );
}
